import CtlNomination from '@/orm/models/CtlNomination'
import { AxiosRepository } from '@pinia-orm/axios'

export default class CtlNominationsRepo extends AxiosRepository<CtlNomination> {
    use = CtlNomination

    transformApiData(data: any[]) {
        return data.flatMap((line) => {
            if (!Object.hasOwn(line, 'nominations'))
                return []

            const ctlId = parseInt(line.id)

            return line.nominations.map((element) => ({
                id: ctlId + '_' + element.memberId + '_' + parseInt(element.roleId),
                ctlId: ctlId,
                regId: String(element.memberId),
                memberId: String(element.memberId).replace('-', ''),
                roleId: parseInt(element.roleId),
            }))
        })
    }

    saveFromApiData(data: any[]) {
        return this.save(this.transformApiData(data))
    }
}
